import './ListOfTickets.css'
import sortByDate from 'tools/sortByDate'
import TicketItem from 'components/TicketItem'

export default function ListOfTickets ({ tickets, path }) {
  return (
    <div className='ListOfTickets'>
      <table>
        <thead>
          <tr className='header'>
            <th>T<span className='tooltip'>Tipo</span></th>
            <th>P<span className='tooltip'>Prioridad</span></th>
            <th>E<span className='tooltip'>Estado</span></th>
            <th>Resumen</th>
            <th>Actualizado</th>
          </tr>
        </thead>
        <tbody>
          {tickets
            .sort((a, b) => {
              // Más reciente primero
              return sortByDate(a.updated, b.updated)
            })
            .map(ticket => <TicketItem key={ticket.id} {...ticket} path={path} />)}
        </tbody>
        <tfoot>
          <tr className='footer'>
            <th>T<span className='tooltip'>Tipo</span></th>
            <th>P<span className='tooltip'>Prioridad</span></th>
            <th>E<span className='tooltip'>Estado</span></th>
            <th>Resumen</th>
            <th>Actualizado</th>
          </tr>
        </tfoot>
      </table>
    </div>
  )
}
